/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import OrganizationDetailsPage from '../../components/people/organizationDetails/organization.details.component';
import { errorfetchingPeople, receiveOrganizations, requestOrganizations } from '../../actions/actions';
import RequestService from '../../service/requestService';

export const mapStateToProps = (state) => {
  return {
    organizations: state.people.organizations,
    sponsor: state.sponsor.selectedSponsor
  };
};

const fetchOrganizations = (dispatch) => (sponsor, isParticipant, offset, limit) => {
  return new Promise((resolve, reject) => {
    dispatch(requestOrganizations());

    return RequestService.getPeopleBySponsor(sponsor, isParticipant, offset, limit)
      .then((response) => {
        dispatch(receiveOrganizations(response.data));
        resolve(response.data.organizations.data);
      })
      .catch((error) => {
        dispatch(errorfetchingPeople(error));
        reject(error);
      });
  });
};

const OrganizationDetailsContainer = connect(mapStateToProps, (dispatch) => ({
  fetchOrganizations: fetchOrganizations(dispatch)
}))(OrganizationDetailsPage);

export default OrganizationDetailsContainer;
